import React from 'react';
import aboutImg from '../../Image/1.jpg';
import why from '../../Image/5.jpg';
import service from '../../Image/2.webp';
import different from '../../Image/different.jpg';
import './About.css';

const About = () => {
  return (
    <div id="About" className="about-section">
      <div className="container">

        {/* Header Section */}
        <div className="section-header">
          <h2 className="text-black font-bold">Xeven Maintenance LLC</h2>
          <div className="separator-line"></div>
        </div>

        {/* Who We Are */}
        <div className="row content-box">
          <div className="col-md-6 text-content">
            <h1 className="titleTwo text-black font-bold">Who We Are?</h1>
            <div className="separator-line"></div>
            <p className="text-black">
              Xeven Maintenance LLC is a trusted property maintenance partner serving homeowners, landlords, and property management companies across the United States. We specialize in delivering fast, efficient, and cost-effective solutions that keep your properties safe, functional, and market-ready. With a dedicated backend team and a growing network of vetted local vendors, we’re redefining how property maintenance is done.
            </p>
          </div>
          <div className="col-md-6 image-content">
            <img className="imageOne" src={aboutImg} alt="Who We Are" />
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="row content-box reverse">
          <div className="col-md-6 image-content">
            <img className="imageOne" src={why} alt="Why Choose Us" />
          </div>
          <div className="col-md-6 text-content">
            <h1 className="titleTwo text-black font-bold">Why Choose Xeven Maintenance LLC?</h1>
            <div className="separator-line"></div>
            <ul className="text-black">
              <li>✅ <strong>Fast Turnaround Times</strong> – We understand time is money. Our streamlined process ensures work orders are addressed promptly.</li>
              <li>✅ <strong>Dedicated Team</strong> – Each client has a responsive account manager overseeing every step.</li>
              <li>✅ <strong>Transparent Communication</strong> – Receive timely updates, photos, and documentation.</li>
              <li>✅ <strong>Nationwide Vendor Network</strong> – Quality service wherever you need it.</li>
              <li>✅ <strong>Tech-Driven Efficiency</strong> – Systems that minimize delays and human error.</li>
            </ul>
          </div>
        </div>

        {/* Services */}
        <div className="row content-box">
          <div className="col-md-6 text-content">
            <h1 className="titleTwo text-black font-bold">Our Services</h1>
            <div className="separator-line"></div>
            <ul className="text-black">
              <li>General Repairs & Handyman Services</li>
              <li>Drywall, Painting & Carpentry</li>
              <li>Plumbing & Electrical Repairs</li>
              <li>Tenant Turn Services</li>
              <li>Trash-Outs & Debris Removal</li>
              <li>Lawn Care & Landscaping</li>
              <li>Winterization & Seasonal Maintenance</li>
              <li>Inspection Reports & Estimates</li>
              <li>Emergency Response Services</li>
            </ul>
            <p className="text-black">Have a custom request? We’re flexible and client-focused. Just reach out!</p>
          </div>
          <div className="col-md-6 image-content">
            <img className="imageOne" src={service} alt="Our Services" />
          </div>
        </div>

        {/* How We're Different */}
        <div className="row content-box reverse">
          <div className="col-md-6 image-content">
            <img className="imageOne" src={different} alt="How We're Different" />
          </div>
          <div className="col-md-6 text-content">
            <h1 className="titleTwo text-black font-bold">How We’re Different</h1>
            <div className="separator-line"></div>
            <ul className="text-black">
              <li>BPO-powered backend team monitoring every step</li>
              <li>Process optimization to reduce delays</li>
              <li>Client-first attitude — we treat your property like our own</li>
              <li>Affordable pricing without compromising quality</li>
              <li>Flexibility to integrate with your portal or system</li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;
